export enum VendorOpportunityTabs {
  General = 'general',
  DealBuilder = 'dealBuilder',
  Tasks = 'tasks',
  Documents = 'documents',
  Submissions = 'submissions',
  Desking = 'desking',
  CreditLine = 'creditLine',
  Insurance = 'insurance',
  Revenue = 'revenue',
  Activity = 'activity',
}
